// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --color-primary: #fd9f29;
  --color-primary-hover: #e88f1f;
  --color-bg-dark: #0c1017;
  --color-bg-card: #191e27;
  --color-text-primary: #ffffff;
  --color-text-secondary: #8b93a1;
  --color-text-muted: #5a6270;
  --color-border: #2a3140;
  --color-success: #4ade80;
  --color-warning: #fbbf24;
  --color-danger: #f87171;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Outfit', sans-serif;
  background-color: var(--color-bg-dark);
  color: var(--color-text-primary);
  min-height: 100vh;
  line-height: 1.5;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

#root {
  min-height: 100vh;
}

/* Scrollbar styling */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: var(--color-bg-dark);
}

::-webkit-scrollbar-thumb {
  background: var(--color-border);
}

::-webkit-scrollbar-thumb:hover {
  background: var(--color-text-muted);
}

/* Selection */
::selection {
  background: var(--color-primary);
  color: var(--color-bg-dark);
}

/* Main App Styles */
* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    border-radius: 0px;
  }
  
   .app {
     min-height: 100vh;
     background-color: var(--color-bg-dark);
     margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */
   }
  
  /* Header */
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px 48px;
    border-bottom: 1px solid var(--color-border);
  }
  
  .logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  
  .logo-icon {
    width: 36px;
    height: 36px;
    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 14px;
    color: var(--color-bg-dark);
  }
  
  .logo-text {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .logo-text span {
    color: var(--color-primary);
  }
  
  .header-tagline {
    color: var(--color-text-secondary);
    font-size: 14px;
  }
  
  .header-tagline span {
    color: var(--color-primary);
  }
  
/* Main Content */
.main-content {
  padding: 40px 48px;
  padding-top: 120px; /* Account for fixed header */
  max-width: 1400px;
  margin: 0 auto;
}
  
  /* Hero Section - Modern Style */
  .hero-section {
    text-align: center;
    padding: 60px 0 40px;
    margin-bottom: 40px;
  }
  
  .hero-title {
    font-size: 56px;
    font-weight: 700;
    color: var(--color-text-primary);
    margin-bottom: 16px;
    letter-spacing: -1px;
  }
  
  .hero-title span {
    color: var(--color-primary);
  }
  
  .hero-subtitle {
    font-size: 18px;
    color: var(--color-text-secondary);
    margin-bottom: 48px;
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
  
  /* Campaign Input Card */
  .campaign-input-card {
    background-color: var(--color-bg-card);
    padding: 24px;
    max-width: 800px;
    margin: 0 auto;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  }
  
  .input-row {
    display: flex;
    gap: 16px;
    align-items: stretch;
    margin-bottom: 16px;
  }
  
  .upload-box {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
    background-color: rgba(90, 98, 112, 0.3);
    border: 1px dashed var(--color-border);
    padding: 16px 20px;
    min-width: 80px;
    cursor: pointer;
    transition: all 0.2s;
  }
  
  .upload-box:hover {
    border-color: var(--color-primary);
    background-color: rgba(253, 159, 41, 0.1);
  }
  
  .upload-icon {
    font-size: 20px;
    color: var(--color-text-muted);
  }
  
  .upload-text {
    font-size: 11px;
    color: var(--color-text-muted);
  }
  
  .campaign-input {
    flex: 1 1;
    background-color: transparent;
    border: none;
    padding: 16px 0;
    color: var(--color-text-primary);
    font-family: 'Outfit', sans-serif;
    font-size: 16px;
  }
  
  .campaign-input::placeholder {
    color: var(--color-text-muted);
  }
  
  .campaign-input:focus {
    outline: none;
  }
  
  /* Examples Horizontal Scroll */
  .examples-scroll-section {
    margin-bottom: 16px;
    overflow: hidden;
  }
  
  .examples-scroll-container {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    padding: 4px 0 12px;
    scrollbar-width: thin;
    scrollbar-color: var(--color-border) transparent;
  }
  
  .examples-scroll-container::-webkit-scrollbar {
    height: 6px;
  }
  
  .examples-scroll-container::-webkit-scrollbar-track {
    background: transparent;
  }
  
  .examples-scroll-container::-webkit-scrollbar-thumb {
    background: var(--color-border);
  }
  
  .example-pill {
    display: flex;
    align-items: center;
    gap: 6px;
    background-color: var(--color-bg-dark);
    border: 1px solid var(--color-border);
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.2s;
    white-space: nowrap;
    flex-shrink: 0;
    font-family: 'Outfit', sans-serif;
  }
  
  .example-pill:hover {
    border-color: var(--color-primary);
    background-color: rgba(253, 159, 41, 0.1);
  }
  
  .pill-brand {
    font-weight: 600;
    color: var(--color-text-primary);
    font-size: 13px;
  }
  
  .pill-desc {
    color: var(--color-text-secondary);
    font-size: 13px;
  }
  
  /* Generate Button */
  .generate-btn {
    width: 100%;
    padding: 16px 24px;
    background: linear-gradient(90deg, var(--color-primary) 0%, #e88f1f 50%, #d4785a 100%);
    border: none;
    color: var(--color-text-primary);
    font-family: 'Outfit', sans-serif;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
  
  .generate-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 20px rgba(253, 159, 41, 0.4);
  }
  
  .generate-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
  
  .btn-arrow {
    font-size: 12px;
  }
  
  /* Results Section */
  .results-section {
    opacity: 0;
    transform: translateY(20px);
    animation: fadeInUp 0.5s ease forwards;
  }
  
  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  /* Campaign Performance */
  .performance-section {
    margin-bottom: 40px;
  }
  
  .performance-title {
    font-size: 20px;
    font-weight: 600;
    color: var(--color-text-primary);
    margin-bottom: 20px;
    padding-left: 12px;
    border-left: 3px solid var(--color-primary);
  }
  
  .performance-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
  }
  
  .performance-card {
    background-color: var(--color-bg-card);
    border-left: 3px solid var(--color-primary);
    padding: 20px;
    position: relative;
  }
  
  .performance-card-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
  }
  
  .performance-card-label {
    font-size: 13px;
    color: var(--color-text-secondary);
  }
  
  .performance-card-icon {
    color: var(--color-primary);
    font-size: 20px;
  }
  
  .performance-card-value {
    font-size: 28px;
    font-weight: 700;
    color: var(--color-text-primary);
    margin-bottom: 4px;
  }
  
  .performance-card-desc {
    font-size: 12px;
    color: var(--color-text-muted);
  }
  
  .performance-card-subtitle {
    font-size: 13px;
    color: var(--color-text-secondary);
  }
  
  /* Influencers Section */
  .influencers-section {
    margin-bottom: 40px;
  }
  
  .influencers-title {
    font-size: 20px;
    font-weight: 600;
    color: var(--color-text-primary);
    margin-bottom: 20px;
    padding-left: 12px;
    border-left: 3px solid var(--color-primary);
  }
  
  /* Filters */
  .filters-bar {
    background-color: var(--color-bg-card);
    border-left: 3px solid var(--color-primary);
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 24px;
    margin-bottom: 20px;
  }
  
  .filters-label {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--color-text-secondary);
    font-size: 14px;
  }
  
  .filter-icon {
    color: var(--color-primary);
  }
  
  .filter-group {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  
  .filter-group label {
    font-size: 13px;
    color: var(--color-text-muted);
  }
  
  .filter-select {
    background-color: var(--color-bg-dark);
    border: 1px solid var(--color-border);
    padding: 8px 12px;
    color: var(--color-text-primary);
    font-family: 'Outfit', sans-serif;
    font-size: 13px;
    min-width: 120px;
    cursor: pointer;
  }
  
  .filter-select:focus {
    outline: none;
    border-color: var(--color-primary);
  }
  
  /* Influencers Table */
  .influencers-table-container {
    background-color: var(--color-bg-card);
    border: 1px solid var(--color-border);
    overflow: hidden;
  }
  
  .table-header-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 20px;
    border-bottom: 1px solid var(--color-border);
  }
  
  .table-header-icon {
    color: var(--color-primary);
    font-size: 18px;
  }
  
  .table-header-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .influencers-table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .influencers-table th {
    text-align: left;
    padding: 14px 16px;
    font-size: 12px;
    font-weight: 500;
    color: var(--color-text-muted);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--color-border);
    white-space: nowrap;
  }
  
  .influencers-table th:nth-child(1) { min-width: 60px; } /* Rank */
  .influencers-table th:nth-child(2) { min-width: 140px; } /* Influencer */
  .influencers-table th:nth-child(3) { min-width: 110px; } /* Platform */
  .influencers-table th:nth-child(4) { min-width: 100px; } /* Followers */
  .influencers-table th:nth-child(5) { min-width: 130px; } /* Engagement Rate */
  .influencers-table th:nth-child(6) { min-width: 150px; } /* Total Engagements */
  .influencers-table th:nth-child(7) { min-width: 140px; } /* EMV */
  .influencers-table th:nth-child(8) { min-width: 70px; } /* Score */
  .influencers-table th:nth-child(9) { min-width: 90px; } /* Risk */
  
  .influencers-table td {
    padding: 20px 16px;
    font-size: 14px;
    color: var(--color-text-primary);
    border-bottom: 1px solid var(--color-border);
    vertical-align: middle;
  }
  
  .influencers-table td:nth-child(4),
  .influencers-table td:nth-child(6) {
    white-space: nowrap;
  }
  
  .influencers-table tr:last-child td {
    border-bottom: none;
  }
  
  .influencer-rank {
    color: var(--color-text-muted);
    font-weight: 500;
    white-space: nowrap;
  }
  
  .influencer-name {
    font-weight: 600;
    font-size: 16px;
    white-space: nowrap;
  }
  
  .platform-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: var(--color-text-secondary);
    font-size: 13px;
    white-space: nowrap;
  }
  
  .platform-icon {
    font-size: 16px;
    flex-shrink: 0;
  }
  
  .engagement-rate {
    color: var(--color-danger);
    white-space: nowrap;
  }
  
  .emv-value {
    color: var(--color-text-primary);
    white-space: nowrap;
  }
  
  .score-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    background-color: var(--color-primary);
    color: var(--color-bg-dark);
    font-weight: 600;
    font-size: 14px;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .risk-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    height: 36px;
    padding: 0 12px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid;
    white-space: nowrap;
    flex-shrink: 0;
  }
  
  .risk-badge.safe {
    color: var(--color-success);
    border-color: var(--color-success);
  }
  
  .risk-badge.moderate {
    color: var(--color-warning);
    border-color: var(--color-warning);
  }
  
  .risk-badge.high {
    color: var(--color-danger);
    border-color: var(--color-danger);
  }
  
  /* Action Insights Cell */
  .action-insights-cell {
    max-width: 220px;
  }
  
  .insights-category {
    margin-bottom: 8px;
  }
  
  .insights-category:last-child {
    margin-bottom: 0;
  }
  
  .insights-label {
    font-size: 11px;
    font-weight: 600;
    margin-bottom: 4px;
  }
  
  .insights-label.strengths {
    color: var(--color-success);
  }
  
  .insights-label.considerations {
    color: var(--color-warning);
  }
  
  .insights-label.actions {
    color: var(--color-primary);
  }
  
  .insights-list {
    list-style: none;
  }
  
  .insights-list li {
    font-size: 12px;
    color: var(--color-text-secondary);
    padding-left: 10px;
    position: relative;
    line-height: 1.4;
  }
  
  .insights-list li::before {
    content: "•";
    position: absolute;
    left: 0;
    color: var(--color-text-muted);
  }
  
  /* View Details Button */
  .view-details-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    background: transparent;
    border: 1px solid var(--color-border);
    padding: 8px 14px;
    color: var(--color-text-primary);
    font-family: 'Outfit', sans-serif;
    font-size: 13px;
    cursor: pointer;
    transition: border-color 0.2s, background-color 0.2s;
    margin-top: 12px;
  }
  
  .view-details-btn:hover {
    border-color: var(--color-primary);
    background-color: rgba(253, 159, 41, 0.1);
  }
  
  /* Modal Overlay */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 40px;
    overflow-y: auto;
  }
  
  .modal-content {
    background-color: var(--color-bg-card);
    border: 1px solid var(--color-border);
    max-width: 900px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
    position: relative;
  }
  
  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 24px;
    border-bottom: 1px solid var(--color-border);
  }
  
  .modal-influencer-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .modal-influencer-icon {
    width: 48px;
    height: 48px;
    background-color: var(--color-bg-dark);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-muted);
    font-size: 24px;
  }
  
  .modal-influencer-name {
    font-size: 24px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .modal-influencer-platform {
    font-size: 14px;
    color: var(--color-text-muted);
  }
  
  .modal-close-btn {
    background: transparent;
    border: none;
    color: var(--color-text-muted);
    font-size: 24px;
    cursor: pointer;
    padding: 8px;
    transition: color 0.2s;
  }
  
  .modal-close-btn:hover {
    color: var(--color-text-primary);
  }
  
  .modal-body {
    padding: 24px;
  }
  
  /* Stats Grid in Modal */
  .modal-stats-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 16px;
    margin-bottom: 32px;
  }
  
  .modal-stat-card {
    background-color: var(--color-bg-dark);
    border-left: 3px solid var(--color-primary);
    padding: 16px;
    text-align: center;
  }
  
  .modal-stat-icon {
    color: var(--color-primary);
    font-size: 20px;
    margin-bottom: 8px;
  }
  
  .modal-stat-value {
    font-size: 24px;
    font-weight: 700;
    color: var(--color-text-primary);
  }
  
  .modal-stat-label {
    font-size: 12px;
    color: var(--color-text-muted);
  }
  
  /* Fit Score Section */
  .fit-score-section {
    margin-bottom: 32px;
  }
  
  .fit-score-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }
  
  .fit-score-icon {
    color: var(--color-primary);
  }
  
  .fit-score-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .fit-score-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
  }
  
  .fit-score-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .fit-score-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .fit-score-label {
    font-size: 13px;
    color: var(--color-text-secondary);
  }
  
  .fit-score-value {
    font-size: 14px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .fit-score-bar {
    height: 6px;
    background-color: var(--color-bg-dark);
    position: relative;
  }
  
  .fit-score-fill {
    height: 100%;
    background-color: var(--color-primary);
    transition: width 0.5s ease;
  }
  
  /* Strengths and Considerations */
  .insights-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 24px;
    margin-bottom: 32px;
  }
  
  .insights-column {
    background-color: var(--color-bg-dark);
    padding: 20px;
  }
  
  .insights-column-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }
  
  .insights-column-icon {
    font-size: 16px;
  }
  
  .insights-column-icon.strengths {
    color: var(--color-success);
  }
  
  .insights-column-icon.considerations {
    color: var(--color-warning);
  }
  
  .insights-column-title {
    font-size: 14px;
    font-weight: 600;
  }
  
  .insights-column-title.strengths {
    color: var(--color-success);
  }
  
  .insights-column-title.considerations {
    color: var(--color-warning);
  }
  
  .insights-column-list {
    list-style: none;
  }
  
  .insights-column-list li {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: var(--color-text-secondary);
    margin-bottom: 10px;
    line-height: 1.5;
  }
  
  .insights-column-list li:last-child {
    margin-bottom: 0;
  }
  
  .insights-bullet {
    width: 6px;
    height: 6px;
    min-width: 6px;
    margin-top: 6px;
  }
  
  .insights-bullet.green {
    background-color: var(--color-success);
  }
  
  .insights-bullet.yellow {
    background-color: var(--color-warning);
  }
  
  /* Campaign Recommendation */
  .campaign-rec-section {
    margin-bottom: 32px;
  }
  
  .campaign-rec-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }
  
  .campaign-rec-icon {
    color: var(--color-primary);
  }
  
  .campaign-rec-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .campaign-rec-card {
    background-color: var(--color-bg-dark);
    border-left: 3px solid var(--color-primary);
    padding: 20px;
  }
  
  .campaign-rec-main {
    margin-bottom: 16px;
  }
  
  .campaign-rec-main-title {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-text-primary);
    margin-bottom: 4px;
  }
  
  .campaign-rec-main-subtitle {
    font-size: 13px;
    color: var(--color-text-secondary);
  }
  
  .campaign-rec-details {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  
  .campaign-rec-detail {
    display: flex;
    gap: 12px;
    font-size: 13px;
  }
  
  .campaign-rec-label {
    color: var(--color-primary);
    font-weight: 500;
    min-width: 120px;
  }
  
  .campaign-rec-value {
    color: var(--color-text-secondary);
  }
  
  /* Top Content Section */
  .top-content-section {
    margin-bottom: 32px;
  }
  
  .top-content-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 16px;
  }
  
  .top-content-icon {
    color: var(--color-danger);
  }
  
  .top-content-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .top-content-card {
    background-color: var(--color-bg-dark);
    padding: 20px;
  }
  
  .top-content-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
  }
  
  .top-content-name {
    font-size: 15px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .top-content-engagement {
    padding: 4px 12px;
    background-color: transparent;
    border: 1px solid var(--color-success);
    color: var(--color-success);
    font-size: 12px;
    font-weight: 500;
  }
  
  .top-content-type {
    font-size: 13px;
    color: var(--color-text-muted);
    margin-bottom: 12px;
  }
  
  .top-content-stats {
    display: flex;
    gap: 20px;
    font-size: 13px;
    color: var(--color-text-secondary);
  }
  
  /* Modal Footer */
  .modal-footer {
    display: flex;
    gap: 12px;
    padding: 24px;
    border-top: 1px solid var(--color-border);
  }
  
  .modal-btn {
    flex: 1 1;
    padding: 14px 20px;
    font-family: 'Outfit', sans-serif;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s, background-color 0.2s;
  }
  
  .modal-btn.primary {
    background: linear-gradient(90deg, var(--color-primary) 0%, #e88f1f 100%);
    border: none;
    color: var(--color-bg-dark);
  }
  
  .modal-btn.secondary {
    background-color: var(--color-bg-dark);
    border: 1px solid var(--color-border);
    color: var(--color-text-primary);
  }
  
  .modal-btn:hover {
    opacity: 0.9;
  }
  
  /* Loading State */
  .loading-overlay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px;
    gap: 16px;
  }
  
  .loading-spinner {
    width: 48px;
    height: 48px;
    border: 3px solid var(--color-border);
    border-top-color: var(--color-primary);
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  .loading-text {
    color: var(--color-text-secondary);
    font-size: 14px;
  }
  
  /* ChatBot Styles */
  .chatbot-toggle-btn {
    position: fixed;
    bottom: 24px;
    right: 24px;
    width: 56px;
    height: 56px;
    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);
    border: none;
    color: var(--color-bg-dark);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    box-shadow: 0 4px 20px rgba(253, 159, 41, 0.4);
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .chatbot-toggle-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(253, 159, 41, 0.5);
  }
  
  .chatbot-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
    padding: 20px;
  }
  
  .chatbot-modal {
    background-color: var(--color-bg-card);
    border: 1px solid var(--color-border);
    width: 100%;
    max-width: 420px;
    height: 600px;
    max-height: 90vh;
    display: flex;
    flex-direction: column;
    position: relative;
    border-radius: 0;
  }
  
  .chatbot-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid var(--color-border);
    background-color: var(--color-bg-dark);
  }
  
  .chatbot-header-info {
    display: flex;
    align-items: center;
    gap: 12px;
  }
  
  .chatbot-avatar {
    width: 40px;
    height: 40px;
    background-color: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-bg-dark);
  }
  
  .chatbot-title {
    font-size: 16px;
    font-weight: 600;
    color: var(--color-text-primary);
  }
  
  .chatbot-subtitle {
    font-size: 12px;
    color: var(--color-text-secondary);
    margin-top: 2px;
  }
  
  .chatbot-close-btn {
    background: transparent;
    border: none;
    color: var(--color-text-muted);
    font-size: 28px;
    cursor: pointer;
    padding: 0;
    width: 32px;
    height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: color 0.2s;
  }
  
  .chatbot-close-btn:hover {
    color: var(--color-text-primary);
  }
  
  .chatbot-messages {
    flex: 1 1;
    overflow-y: auto;
    padding: 20px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: var(--color-bg-card);
  }
  
  .chatbot-message {
    display: flex;
    gap: 10px;
    align-items: flex-start;
  }
  
  .chatbot-message.ai-message {
    justify-content: flex-start;
  }
  
  .chatbot-message.user-message {
    justify-content: flex-end;
  }
  
  .chatbot-avatar-small {
    width: 28px;
    height: 28px;
    background-color: var(--color-primary);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-bg-dark);
    flex-shrink: 0;
  }
  
  .chatbot-message-content {
    max-width: 75%;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
  
  .user-message .chatbot-message-content {
    align-items: flex-end;
  }
  
  .chatbot-message-text {
    padding: 12px 16px;
    font-size: 14px;
    line-height: 1.5;
    word-wrap: break-word;
    border-radius: 0;
  }
  
  .ai-message .chatbot-message-text {
    background-color: var(--color-bg-dark);
    color: var(--color-text-primary);
    border: 1px solid var(--color-border);
  }
  
  .user-message .chatbot-message-text {
    background-color: var(--color-primary);
    color: var(--color-bg-dark);
  }
  
  .chatbot-message-time {
    font-size: 11px;
    color: var(--color-text-muted);
    padding: 0 4px;
  }
  
  .chatbot-input-form {
    display: flex;
    gap: 10px;
    padding: 16px 20px;
    border-top: 1px solid var(--color-border);
    background-color: var(--color-bg-dark);
  }
  
  .chatbot-input {
    flex: 1 1;
    background-color: var(--color-bg-card);
    border: 1px solid var(--color-border);
    padding: 12px 16px;
    color: var(--color-text-primary);
    font-family: 'Outfit', sans-serif;
    font-size: 14px;
    border-radius: 0;
  }
  
  .chatbot-input::placeholder {
    color: var(--color-text-muted);
  }
  
  .chatbot-input:focus {
    outline: none;
    border-color: var(--color-primary);
  }
  
  .chatbot-send-btn {
    width: 44px;
    height: 44px;
    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);
    border: none;
    color: var(--color-bg-dark);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: opacity 0.2s;
    flex-shrink: 0;
    border-radius: 0;
  }
  
  .chatbot-send-btn:hover:not(:disabled) {
    opacity: 0.9;
  }
  
  .chatbot-send-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
  
  /* Responsive */
  @media (max-width: 1200px) {
    .performance-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .modal-stats-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .fit-score-grid {
      grid-template-columns: repeat(3, 1fr);
    }
    
    .hero-title {
      font-size: 42px;
    }
  }
  
  @media (max-width: 768px) {
    .header {
      flex-direction: column;
      gap: 12px;
      padding: 16px 24px;
    }
    
    .main-content {
      padding: 24px;
    }
    
    .hero-title {
      font-size: 32px;
    }
    
    .hero-subtitle {
      font-size: 15px;
    }
    
    .campaign-input-card {
      padding: 16px;
    }
    
    .input-row {
      flex-direction: column;
    }
    
    .upload-box {
      flex-direction: row;
      padding: 12px 16px;
    }
    
    .performance-grid {
      grid-template-columns: 1fr;
    }
    
    .filters-bar {
      flex-wrap: wrap;
    }
    
    .influencers-table {
      display: block;
      overflow-x: auto;
    }
    
    .insights-grid {
      grid-template-columns: 1fr;
    }
    
    .modal-stats-grid {
      grid-template-columns: 1fr;
    }
    
    .fit-score-grid {
      grid-template-columns: repeat(2, 1fr);
    }
    
    .modal-footer {
      flex-direction: column;
    }
  }
`, "",{"version":3,"sources":["webpack://./src/assets/css/InfluencerIQ/style.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,6BAA6B;EAC7B,+BAA+B;EAC/B,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;IACI,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,kBAAkB;EACpB;;GAEC;KACE,iBAAiB;KACjB,sCAAsC;KACtC,iBAAiB,EAAE,6DAA6D;GAClF;;EAED,WAAW;EACX;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0EAA0E;IAC1E,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,eAAe;IACf,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;AAEF,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB,EAAE,6BAA6B;EACjD,iBAAiB;EACjB,cAAc;AAChB;;EAEE,gCAAgC;EAChC;IACE,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,wBAAwB;EACxB;IACE,sCAAsC;IACtC,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,SAAS;IACT,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,wCAAwC;IACxC,sCAAsC;IACtC,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,kCAAkC;IAClC,yCAAyC;EAC3C;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,SAAO;IACP,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;EACf;;EAEA,+BAA+B;EAC/B;IACE,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;IACrB,gDAAgD;EAClD;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sCAAsC;IACtC,qCAAqC;IACrC,iBAAiB;IACjB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,iCAAiC;EACnC;;EAEA;IACE,kCAAkC;IAClC,yCAAyC;EAC3C;;EAEA;IACE,gBAAgB;IAChB,gCAAgC;IAChC,eAAe;EACjB;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,kBAAkB;IAClB,sFAAsF;IACtF,YAAY;IACZ,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,2BAA2B;IAC3B,8CAA8C;EAChD;;EAEA;IACE,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA,oBAAoB;EACpB;IACE,UAAU;IACV,2BAA2B;IAC3B,sCAAsC;EACxC;;EAEA;IACE;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA,yBAAyB;EACzB;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,sCAAsC;IACtC,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;EAC7C;;EAEA,YAAY;EACZ;IACE,sCAAsC;IACtC,2CAA2C;IAC3C,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;IACrC,iBAAiB;IACjB,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,kCAAkC;EACpC;;EAEA,sBAAsB;EACtB;IACE,sCAAsC;IACtC,qCAAqC;IACrC,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,2BAA2B;IAC3B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;IACrB,4CAA4C;IAC5C,mBAAmB;EACrB;;EAEA,qCAAqC,eAAe,EAAE,EAAE,SAAS;EACjE,qCAAqC,gBAAgB,EAAE,EAAE,eAAe;EACxE,qCAAqC,gBAAgB,EAAE,EAAE,aAAa;EACtE,qCAAqC,gBAAgB,EAAE,EAAE,cAAc;EACvE,qCAAqC,gBAAgB,EAAE,EAAE,oBAAoB;EAC7E,qCAAqC,gBAAgB,EAAE,EAAE,sBAAsB;EAC/E,qCAAqC,gBAAgB,EAAE,EAAE,QAAQ;EACjE,qCAAqC,eAAe,EAAE,EAAE,UAAU;EAClE,qCAAqC,eAAe,EAAE,EAAE,SAAS;;EAEjE;IACE,kBAAkB;IAClB,eAAe;IACf,gCAAgC;IAChC,4CAA4C;IAC5C,sBAAsB;EACxB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,kCAAkC;IAClC,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,mBAAmB;EACrB;;EAEA;IACE,gCAAgC;IAChC,mBAAmB;EACrB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,2BAA2B;IAC3B,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,2BAA2B;IAC3B,kCAAkC;EACpC;;EAEA;IACE,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA,yBAAyB;EACzB;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,OAAO;IACP,8BAA8B;EAChC;;EAEA,wBAAwB;EACxB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,uBAAuB;IACvB,qCAAqC;IACrC,iBAAiB;IACjB,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;IACf,eAAe;IACf,oDAAoD;IACpD,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;IAClC,yCAAyC;EAC3C;;EAEA,kBAAkB;EAClB;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;IACrC,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,aAAa;IACb,4CAA4C;EAC9C;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,aAAa;EACf;;EAEA,wBAAwB;EACxB;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,2CAA2C;IAC3C,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,2BAA2B;IAC3B,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,8BAA8B;EAChC;;EAEA,sBAAsB;EACtB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,aAAa;IACb,qCAAqC;IACrC,SAAS;EACX;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,sCAAsC;IACtC,kBAAkB;EACpB;;EAEA;IACE,YAAY;IACZ,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA,iCAAiC;EACjC;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,eAAe;IACf,kCAAkC;IAClC,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;IACV,WAAW;IACX,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,sCAAsC;EACxC;;EAEA;IACE,sCAAsC;EACxC;;EAEA,4BAA4B;EAC5B;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,kCAAkC;EACpC;;EAEA,wBAAwB;EACxB;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,sCAAsC;IACtC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,iBAAiB;IACjB,6BAA6B;IAC7B,sCAAsC;IACtC,2BAA2B;IAC3B,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,eAAe;IACf,kCAAkC;EACpC;;EAEA,iBAAiB;EACjB;IACE,aAAa;IACb,SAAS;IACT,aAAa;IACb,yCAAyC;EAC3C;;EAEA;IACE,SAAO;IACP,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,+CAA+C;EACjD;;EAEA;IACE,yEAAyE;IACzE,YAAY;IACZ,2BAA2B;EAC7B;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;IACrC,gCAAgC;EAClC;;EAEA;IACE,YAAY;EACd;;EAEA,kBAAkB;EAClB;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,sCAAsC;IACtC,kBAAkB;IAClB,kCAAkC;EACpC;;EAEA;IACE;MACE,yBAAyB;IAC3B;EACF;;EAEA;IACE,kCAAkC;IAClC,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,0EAA0E;IAC1E,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,8CAA8C;IAC9C,2CAA2C;EAC7C;;EAEA;IACE,sBAAsB;IACtB,8CAA8C;EAChD;;EAEA;IACE,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,aAAa;EACf;;EAEA;IACE,sCAAsC;IACtC,qCAAqC;IACrC,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,4CAA4C;IAC5C,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,gCAAgC;EAClC;;EAEA;IACE,eAAe;IACf,kCAAkC;IAClC,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,YAAY;IACZ,8BAA8B;IAC9B,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,sCAAsC;EACxC;;EAEA;IACE,aAAa;IACb,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;EAClB;;EAEA;IACE,sCAAsC;IACtC,gCAAgC;IAChC,qCAAqC;EACvC;;EAEA;IACE,sCAAsC;IACtC,2BAA2B;EAC7B;;EAEA;IACE,eAAe;IACf,8BAA8B;IAC9B,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,yCAAyC;IACzC,sCAAsC;EACxC;;EAEA;IACE,SAAO;IACP,sCAAsC;IACtC,qCAAqC;IACrC,kBAAkB;IAClB,gCAAgC;IAChC,iCAAiC;IACjC,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,kCAAkC;EACpC;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,0EAA0E;IAC1E,YAAY;IACZ,2BAA2B;IAC3B,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,mBAAmB;EACrB;;EAEA,eAAe;EACf;IACE;MACE,qCAAqC;IACvC;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,eAAe;IACjB;EACF;;EAEA;IACE;MACE,sBAAsB;MACtB,SAAS;MACT,kBAAkB;IACpB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,sBAAsB;IACxB;;IAEA;MACE,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,eAAe;IACjB;;IAEA;MACE,cAAc;MACd,gBAAgB;IAClB;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,0BAA0B;IAC5B;;IAEA;MACE,qCAAqC;IACvC;;IAEA;MACE,sBAAsB;IACxB;EACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n:root {\n  --color-primary: #fd9f29;\n  --color-primary-hover: #e88f1f;\n  --color-bg-dark: #0c1017;\n  --color-bg-card: #191e27;\n  --color-text-primary: #ffffff;\n  --color-text-secondary: #8b93a1;\n  --color-text-muted: #5a6270;\n  --color-border: #2a3140;\n  --color-success: #4ade80;\n  --color-warning: #fbbf24;\n  --color-danger: #f87171;\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nbody {\n  font-family: 'Outfit', sans-serif;\n  background-color: var(--color-bg-dark);\n  color: var(--color-text-primary);\n  min-height: 100vh;\n  line-height: 1.5;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n#root {\n  min-height: 100vh;\n}\n\n/* Scrollbar styling */\n::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n::-webkit-scrollbar-track {\n  background: var(--color-bg-dark);\n}\n\n::-webkit-scrollbar-thumb {\n  background: var(--color-border);\n}\n\n::-webkit-scrollbar-thumb:hover {\n  background: var(--color-text-muted);\n}\n\n/* Selection */\n::selection {\n  background: var(--color-primary);\n  color: var(--color-bg-dark);\n}\n\n/* Main App Styles */\n* {\n    margin: 0;\n    padding: 0;\n    box-sizing: border-box;\n    border-radius: 0px;\n  }\n  \n   .app {\n     min-height: 100vh;\n     background-color: var(--color-bg-dark);\n     margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */\n   }\n  \n  /* Header */\n  .header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px 48px;\n    border-bottom: 1px solid var(--color-border);\n  }\n  \n  .logo {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n  }\n  \n  .logo-icon {\n    width: 36px;\n    height: 36px;\n    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    font-size: 14px;\n    color: var(--color-bg-dark);\n  }\n  \n  .logo-text {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .logo-text span {\n    color: var(--color-primary);\n  }\n  \n  .header-tagline {\n    color: var(--color-text-secondary);\n    font-size: 14px;\n  }\n  \n  .header-tagline span {\n    color: var(--color-primary);\n  }\n  \n/* Main Content */\n.main-content {\n  padding: 40px 48px;\n  padding-top: 120px; /* Account for fixed header */\n  max-width: 1400px;\n  margin: 0 auto;\n}\n  \n  /* Hero Section - Modern Style */\n  .hero-section {\n    text-align: center;\n    padding: 60px 0 40px;\n    margin-bottom: 40px;\n  }\n  \n  .hero-title {\n    font-size: 56px;\n    font-weight: 700;\n    color: var(--color-text-primary);\n    margin-bottom: 16px;\n    letter-spacing: -1px;\n  }\n  \n  .hero-title span {\n    color: var(--color-primary);\n  }\n  \n  .hero-subtitle {\n    font-size: 18px;\n    color: var(--color-text-secondary);\n    margin-bottom: 48px;\n    max-width: 600px;\n    margin-left: auto;\n    margin-right: auto;\n  }\n  \n  /* Campaign Input Card */\n  .campaign-input-card {\n    background-color: var(--color-bg-card);\n    padding: 24px;\n    max-width: 800px;\n    margin: 0 auto;\n    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  }\n  \n  .input-row {\n    display: flex;\n    gap: 16px;\n    align-items: stretch;\n    margin-bottom: 16px;\n  }\n  \n  .upload-box {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    background-color: rgba(90, 98, 112, 0.3);\n    border: 1px dashed var(--color-border);\n    padding: 16px 20px;\n    min-width: 80px;\n    cursor: pointer;\n    transition: all 0.2s;\n  }\n  \n  .upload-box:hover {\n    border-color: var(--color-primary);\n    background-color: rgba(253, 159, 41, 0.1);\n  }\n  \n  .upload-icon {\n    font-size: 20px;\n    color: var(--color-text-muted);\n  }\n  \n  .upload-text {\n    font-size: 11px;\n    color: var(--color-text-muted);\n  }\n  \n  .campaign-input {\n    flex: 1;\n    background-color: transparent;\n    border: none;\n    padding: 16px 0;\n    color: var(--color-text-primary);\n    font-family: 'Outfit', sans-serif;\n    font-size: 16px;\n  }\n  \n  .campaign-input::placeholder {\n    color: var(--color-text-muted);\n  }\n  \n  .campaign-input:focus {\n    outline: none;\n  }\n  \n  /* Examples Horizontal Scroll */\n  .examples-scroll-section {\n    margin-bottom: 16px;\n    overflow: hidden;\n  }\n  \n  .examples-scroll-container {\n    display: flex;\n    gap: 10px;\n    overflow-x: auto;\n    padding: 4px 0 12px;\n    scrollbar-width: thin;\n    scrollbar-color: var(--color-border) transparent;\n  }\n  \n  .examples-scroll-container::-webkit-scrollbar {\n    height: 6px;\n  }\n  \n  .examples-scroll-container::-webkit-scrollbar-track {\n    background: transparent;\n  }\n  \n  .examples-scroll-container::-webkit-scrollbar-thumb {\n    background: var(--color-border);\n  }\n  \n  .example-pill {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    background-color: var(--color-bg-dark);\n    border: 1px solid var(--color-border);\n    padding: 8px 16px;\n    cursor: pointer;\n    transition: all 0.2s;\n    white-space: nowrap;\n    flex-shrink: 0;\n    font-family: 'Outfit', sans-serif;\n  }\n  \n  .example-pill:hover {\n    border-color: var(--color-primary);\n    background-color: rgba(253, 159, 41, 0.1);\n  }\n  \n  .pill-brand {\n    font-weight: 600;\n    color: var(--color-text-primary);\n    font-size: 13px;\n  }\n  \n  .pill-desc {\n    color: var(--color-text-secondary);\n    font-size: 13px;\n  }\n  \n  /* Generate Button */\n  .generate-btn {\n    width: 100%;\n    padding: 16px 24px;\n    background: linear-gradient(90deg, var(--color-primary) 0%, #e88f1f 50%, #d4785a 100%);\n    border: none;\n    color: var(--color-text-primary);\n    font-family: 'Outfit', sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.2s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n  }\n  \n  .generate-btn:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 4px 20px rgba(253, 159, 41, 0.4);\n  }\n  \n  .generate-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n    box-shadow: none;\n  }\n  \n  .btn-arrow {\n    font-size: 12px;\n  }\n  \n  /* Results Section */\n  .results-section {\n    opacity: 0;\n    transform: translateY(20px);\n    animation: fadeInUp 0.5s ease forwards;\n  }\n  \n  @keyframes fadeInUp {\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  /* Campaign Performance */\n  .performance-section {\n    margin-bottom: 40px;\n  }\n  \n  .performance-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin-bottom: 20px;\n    padding-left: 12px;\n    border-left: 3px solid var(--color-primary);\n  }\n  \n  .performance-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n  }\n  \n  .performance-card {\n    background-color: var(--color-bg-card);\n    border-left: 3px solid var(--color-primary);\n    padding: 20px;\n    position: relative;\n  }\n  \n  .performance-card-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 8px;\n  }\n  \n  .performance-card-label {\n    font-size: 13px;\n    color: var(--color-text-secondary);\n  }\n  \n  .performance-card-icon {\n    color: var(--color-primary);\n    font-size: 20px;\n  }\n  \n  .performance-card-value {\n    font-size: 28px;\n    font-weight: 700;\n    color: var(--color-text-primary);\n    margin-bottom: 4px;\n  }\n  \n  .performance-card-desc {\n    font-size: 12px;\n    color: var(--color-text-muted);\n  }\n  \n  .performance-card-subtitle {\n    font-size: 13px;\n    color: var(--color-text-secondary);\n  }\n  \n  /* Influencers Section */\n  .influencers-section {\n    margin-bottom: 40px;\n  }\n  \n  .influencers-title {\n    font-size: 20px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin-bottom: 20px;\n    padding-left: 12px;\n    border-left: 3px solid var(--color-primary);\n  }\n  \n  /* Filters */\n  .filters-bar {\n    background-color: var(--color-bg-card);\n    border-left: 3px solid var(--color-primary);\n    padding: 16px 20px;\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    margin-bottom: 20px;\n  }\n  \n  .filters-label {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    color: var(--color-text-secondary);\n    font-size: 14px;\n  }\n  \n  .filter-icon {\n    color: var(--color-primary);\n  }\n  \n  .filter-group {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .filter-group label {\n    font-size: 13px;\n    color: var(--color-text-muted);\n  }\n  \n  .filter-select {\n    background-color: var(--color-bg-dark);\n    border: 1px solid var(--color-border);\n    padding: 8px 12px;\n    color: var(--color-text-primary);\n    font-family: 'Outfit', sans-serif;\n    font-size: 13px;\n    min-width: 120px;\n    cursor: pointer;\n  }\n  \n  .filter-select:focus {\n    outline: none;\n    border-color: var(--color-primary);\n  }\n  \n  /* Influencers Table */\n  .influencers-table-container {\n    background-color: var(--color-bg-card);\n    border: 1px solid var(--color-border);\n    overflow: hidden;\n  }\n  \n  .table-header-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 16px 20px;\n    border-bottom: 1px solid var(--color-border);\n  }\n  \n  .table-header-icon {\n    color: var(--color-primary);\n    font-size: 18px;\n  }\n  \n  .table-header-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .influencers-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .influencers-table th {\n    text-align: left;\n    padding: 14px 16px;\n    font-size: 12px;\n    font-weight: 500;\n    color: var(--color-text-muted);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    border-bottom: 1px solid var(--color-border);\n    white-space: nowrap;\n  }\n  \n  .influencers-table th:nth-child(1) { min-width: 60px; } /* Rank */\n  .influencers-table th:nth-child(2) { min-width: 140px; } /* Influencer */\n  .influencers-table th:nth-child(3) { min-width: 110px; } /* Platform */\n  .influencers-table th:nth-child(4) { min-width: 100px; } /* Followers */\n  .influencers-table th:nth-child(5) { min-width: 130px; } /* Engagement Rate */\n  .influencers-table th:nth-child(6) { min-width: 150px; } /* Total Engagements */\n  .influencers-table th:nth-child(7) { min-width: 140px; } /* EMV */\n  .influencers-table th:nth-child(8) { min-width: 70px; } /* Score */\n  .influencers-table th:nth-child(9) { min-width: 90px; } /* Risk */\n  \n  .influencers-table td {\n    padding: 20px 16px;\n    font-size: 14px;\n    color: var(--color-text-primary);\n    border-bottom: 1px solid var(--color-border);\n    vertical-align: middle;\n  }\n  \n  .influencers-table td:nth-child(4),\n  .influencers-table td:nth-child(6) {\n    white-space: nowrap;\n  }\n  \n  .influencers-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .influencer-rank {\n    color: var(--color-text-muted);\n    font-weight: 500;\n    white-space: nowrap;\n  }\n  \n  .influencer-name {\n    font-weight: 600;\n    font-size: 16px;\n    white-space: nowrap;\n  }\n  \n  .platform-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: var(--color-text-secondary);\n    font-size: 13px;\n    white-space: nowrap;\n  }\n  \n  .platform-icon {\n    font-size: 16px;\n    flex-shrink: 0;\n  }\n  \n  .engagement-rate {\n    color: var(--color-danger);\n    white-space: nowrap;\n  }\n  \n  .emv-value {\n    color: var(--color-text-primary);\n    white-space: nowrap;\n  }\n  \n  .score-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    width: 36px;\n    height: 36px;\n    background-color: var(--color-primary);\n    color: var(--color-bg-dark);\n    font-weight: 600;\n    font-size: 14px;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n  \n  .risk-badge {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n    height: 36px;\n    padding: 0 12px;\n    font-size: 12px;\n    font-weight: 500;\n    border: 1px solid;\n    white-space: nowrap;\n    flex-shrink: 0;\n  }\n  \n  .risk-badge.safe {\n    color: var(--color-success);\n    border-color: var(--color-success);\n  }\n  \n  .risk-badge.moderate {\n    color: var(--color-warning);\n    border-color: var(--color-warning);\n  }\n  \n  .risk-badge.high {\n    color: var(--color-danger);\n    border-color: var(--color-danger);\n  }\n  \n  /* Action Insights Cell */\n  .action-insights-cell {\n    max-width: 220px;\n  }\n  \n  .insights-category {\n    margin-bottom: 8px;\n  }\n  \n  .insights-category:last-child {\n    margin-bottom: 0;\n  }\n  \n  .insights-label {\n    font-size: 11px;\n    font-weight: 600;\n    margin-bottom: 4px;\n  }\n  \n  .insights-label.strengths {\n    color: var(--color-success);\n  }\n  \n  .insights-label.considerations {\n    color: var(--color-warning);\n  }\n  \n  .insights-label.actions {\n    color: var(--color-primary);\n  }\n  \n  .insights-list {\n    list-style: none;\n  }\n  \n  .insights-list li {\n    font-size: 12px;\n    color: var(--color-text-secondary);\n    padding-left: 10px;\n    position: relative;\n    line-height: 1.4;\n  }\n  \n  .insights-list li::before {\n    content: \"•\";\n    position: absolute;\n    left: 0;\n    color: var(--color-text-muted);\n  }\n  \n  /* View Details Button */\n  .view-details-btn {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    background: transparent;\n    border: 1px solid var(--color-border);\n    padding: 8px 14px;\n    color: var(--color-text-primary);\n    font-family: 'Outfit', sans-serif;\n    font-size: 13px;\n    cursor: pointer;\n    transition: border-color 0.2s, background-color 0.2s;\n    margin-top: 12px;\n  }\n  \n  .view-details-btn:hover {\n    border-color: var(--color-primary);\n    background-color: rgba(253, 159, 41, 0.1);\n  }\n  \n  /* Modal Overlay */\n  .modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 40px;\n    overflow-y: auto;\n  }\n  \n  .modal-content {\n    background-color: var(--color-bg-card);\n    border: 1px solid var(--color-border);\n    max-width: 900px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n    position: relative;\n  }\n  \n  .modal-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    padding: 24px;\n    border-bottom: 1px solid var(--color-border);\n  }\n  \n  .modal-influencer-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .modal-influencer-icon {\n    width: 48px;\n    height: 48px;\n    background-color: var(--color-bg-dark);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-text-muted);\n    font-size: 24px;\n  }\n  \n  .modal-influencer-name {\n    font-size: 24px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .modal-influencer-platform {\n    font-size: 14px;\n    color: var(--color-text-muted);\n  }\n  \n  .modal-close-btn {\n    background: transparent;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 24px;\n    cursor: pointer;\n    padding: 8px;\n    transition: color 0.2s;\n  }\n  \n  .modal-close-btn:hover {\n    color: var(--color-text-primary);\n  }\n  \n  .modal-body {\n    padding: 24px;\n  }\n  \n  /* Stats Grid in Modal */\n  .modal-stats-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 16px;\n    margin-bottom: 32px;\n  }\n  \n  .modal-stat-card {\n    background-color: var(--color-bg-dark);\n    border-left: 3px solid var(--color-primary);\n    padding: 16px;\n    text-align: center;\n  }\n  \n  .modal-stat-icon {\n    color: var(--color-primary);\n    font-size: 20px;\n    margin-bottom: 8px;\n  }\n  \n  .modal-stat-value {\n    font-size: 24px;\n    font-weight: 700;\n    color: var(--color-text-primary);\n  }\n  \n  .modal-stat-label {\n    font-size: 12px;\n    color: var(--color-text-muted);\n  }\n  \n  /* Fit Score Section */\n  .fit-score-section {\n    margin-bottom: 32px;\n  }\n  \n  .fit-score-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n  \n  .fit-score-icon {\n    color: var(--color-primary);\n  }\n  \n  .fit-score-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .fit-score-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n  }\n  \n  .fit-score-item {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .fit-score-label-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n  \n  .fit-score-label {\n    font-size: 13px;\n    color: var(--color-text-secondary);\n  }\n  \n  .fit-score-value {\n    font-size: 14px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .fit-score-bar {\n    height: 6px;\n    background-color: var(--color-bg-dark);\n    position: relative;\n  }\n  \n  .fit-score-fill {\n    height: 100%;\n    background-color: var(--color-primary);\n    transition: width 0.5s ease;\n  }\n  \n  /* Strengths and Considerations */\n  .insights-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    margin-bottom: 32px;\n  }\n  \n  .insights-column {\n    background-color: var(--color-bg-dark);\n    padding: 20px;\n  }\n  \n  .insights-column-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n  \n  .insights-column-icon {\n    font-size: 16px;\n  }\n  \n  .insights-column-icon.strengths {\n    color: var(--color-success);\n  }\n  \n  .insights-column-icon.considerations {\n    color: var(--color-warning);\n  }\n  \n  .insights-column-title {\n    font-size: 14px;\n    font-weight: 600;\n  }\n  \n  .insights-column-title.strengths {\n    color: var(--color-success);\n  }\n  \n  .insights-column-title.considerations {\n    color: var(--color-warning);\n  }\n  \n  .insights-column-list {\n    list-style: none;\n  }\n  \n  .insights-column-list li {\n    display: flex;\n    align-items: flex-start;\n    gap: 8px;\n    font-size: 13px;\n    color: var(--color-text-secondary);\n    margin-bottom: 10px;\n    line-height: 1.5;\n  }\n  \n  .insights-column-list li:last-child {\n    margin-bottom: 0;\n  }\n  \n  .insights-bullet {\n    width: 6px;\n    height: 6px;\n    min-width: 6px;\n    margin-top: 6px;\n  }\n  \n  .insights-bullet.green {\n    background-color: var(--color-success);\n  }\n  \n  .insights-bullet.yellow {\n    background-color: var(--color-warning);\n  }\n  \n  /* Campaign Recommendation */\n  .campaign-rec-section {\n    margin-bottom: 32px;\n  }\n  \n  .campaign-rec-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n  \n  .campaign-rec-icon {\n    color: var(--color-primary);\n  }\n  \n  .campaign-rec-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .campaign-rec-card {\n    background-color: var(--color-bg-dark);\n    border-left: 3px solid var(--color-primary);\n    padding: 20px;\n  }\n  \n  .campaign-rec-main {\n    margin-bottom: 16px;\n  }\n  \n  .campaign-rec-main-title {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n    margin-bottom: 4px;\n  }\n  \n  .campaign-rec-main-subtitle {\n    font-size: 13px;\n    color: var(--color-text-secondary);\n  }\n  \n  .campaign-rec-details {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n  \n  .campaign-rec-detail {\n    display: flex;\n    gap: 12px;\n    font-size: 13px;\n  }\n  \n  .campaign-rec-label {\n    color: var(--color-primary);\n    font-weight: 500;\n    min-width: 120px;\n  }\n  \n  .campaign-rec-value {\n    color: var(--color-text-secondary);\n  }\n  \n  /* Top Content Section */\n  .top-content-section {\n    margin-bottom: 32px;\n  }\n  \n  .top-content-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 16px;\n  }\n  \n  .top-content-icon {\n    color: var(--color-danger);\n  }\n  \n  .top-content-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .top-content-card {\n    background-color: var(--color-bg-dark);\n    padding: 20px;\n  }\n  \n  .top-content-main {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    margin-bottom: 8px;\n  }\n  \n  .top-content-name {\n    font-size: 15px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .top-content-engagement {\n    padding: 4px 12px;\n    background-color: transparent;\n    border: 1px solid var(--color-success);\n    color: var(--color-success);\n    font-size: 12px;\n    font-weight: 500;\n  }\n  \n  .top-content-type {\n    font-size: 13px;\n    color: var(--color-text-muted);\n    margin-bottom: 12px;\n  }\n  \n  .top-content-stats {\n    display: flex;\n    gap: 20px;\n    font-size: 13px;\n    color: var(--color-text-secondary);\n  }\n  \n  /* Modal Footer */\n  .modal-footer {\n    display: flex;\n    gap: 12px;\n    padding: 24px;\n    border-top: 1px solid var(--color-border);\n  }\n  \n  .modal-btn {\n    flex: 1;\n    padding: 14px 20px;\n    font-family: 'Outfit', sans-serif;\n    font-size: 14px;\n    font-weight: 500;\n    cursor: pointer;\n    transition: opacity 0.2s, background-color 0.2s;\n  }\n  \n  .modal-btn.primary {\n    background: linear-gradient(90deg, var(--color-primary) 0%, #e88f1f 100%);\n    border: none;\n    color: var(--color-bg-dark);\n  }\n  \n  .modal-btn.secondary {\n    background-color: var(--color-bg-dark);\n    border: 1px solid var(--color-border);\n    color: var(--color-text-primary);\n  }\n  \n  .modal-btn:hover {\n    opacity: 0.9;\n  }\n  \n  /* Loading State */\n  .loading-overlay {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 60px;\n    gap: 16px;\n  }\n  \n  .loading-spinner {\n    width: 48px;\n    height: 48px;\n    border: 3px solid var(--color-border);\n    border-top-color: var(--color-primary);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n  }\n  \n  @keyframes spin {\n    to {\n      transform: rotate(360deg);\n    }\n  }\n  \n  .loading-text {\n    color: var(--color-text-secondary);\n    font-size: 14px;\n  }\n  \n  /* ChatBot Styles */\n  .chatbot-toggle-btn {\n    position: fixed;\n    bottom: 24px;\n    right: 24px;\n    width: 56px;\n    height: 56px;\n    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);\n    border: none;\n    color: var(--color-bg-dark);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999;\n    box-shadow: 0 4px 20px rgba(253, 159, 41, 0.4);\n    transition: transform 0.2s, box-shadow 0.2s;\n  }\n  \n  .chatbot-toggle-btn:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 24px rgba(253, 159, 41, 0.5);\n  }\n  \n  .chatbot-modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.7);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 1000;\n    padding: 20px;\n  }\n  \n  .chatbot-modal {\n    background-color: var(--color-bg-card);\n    border: 1px solid var(--color-border);\n    width: 100%;\n    max-width: 420px;\n    height: 600px;\n    max-height: 90vh;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    border-radius: 0;\n  }\n  \n  .chatbot-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 20px;\n    border-bottom: 1px solid var(--color-border);\n    background-color: var(--color-bg-dark);\n  }\n  \n  .chatbot-header-info {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n  }\n  \n  .chatbot-avatar {\n    width: 40px;\n    height: 40px;\n    background-color: var(--color-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-bg-dark);\n  }\n  \n  .chatbot-title {\n    font-size: 16px;\n    font-weight: 600;\n    color: var(--color-text-primary);\n  }\n  \n  .chatbot-subtitle {\n    font-size: 12px;\n    color: var(--color-text-secondary);\n    margin-top: 2px;\n  }\n  \n  .chatbot-close-btn {\n    background: transparent;\n    border: none;\n    color: var(--color-text-muted);\n    font-size: 28px;\n    cursor: pointer;\n    padding: 0;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: color 0.2s;\n  }\n  \n  .chatbot-close-btn:hover {\n    color: var(--color-text-primary);\n  }\n  \n  .chatbot-messages {\n    flex: 1;\n    overflow-y: auto;\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    background-color: var(--color-bg-card);\n  }\n  \n  .chatbot-message {\n    display: flex;\n    gap: 10px;\n    align-items: flex-start;\n  }\n  \n  .chatbot-message.ai-message {\n    justify-content: flex-start;\n  }\n  \n  .chatbot-message.user-message {\n    justify-content: flex-end;\n  }\n  \n  .chatbot-avatar-small {\n    width: 28px;\n    height: 28px;\n    background-color: var(--color-primary);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-bg-dark);\n    flex-shrink: 0;\n  }\n  \n  .chatbot-message-content {\n    max-width: 75%;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n  }\n  \n  .user-message .chatbot-message-content {\n    align-items: flex-end;\n  }\n  \n  .chatbot-message-text {\n    padding: 12px 16px;\n    font-size: 14px;\n    line-height: 1.5;\n    word-wrap: break-word;\n    border-radius: 0;\n  }\n  \n  .ai-message .chatbot-message-text {\n    background-color: var(--color-bg-dark);\n    color: var(--color-text-primary);\n    border: 1px solid var(--color-border);\n  }\n  \n  .user-message .chatbot-message-text {\n    background-color: var(--color-primary);\n    color: var(--color-bg-dark);\n  }\n  \n  .chatbot-message-time {\n    font-size: 11px;\n    color: var(--color-text-muted);\n    padding: 0 4px;\n  }\n  \n  .chatbot-input-form {\n    display: flex;\n    gap: 10px;\n    padding: 16px 20px;\n    border-top: 1px solid var(--color-border);\n    background-color: var(--color-bg-dark);\n  }\n  \n  .chatbot-input {\n    flex: 1;\n    background-color: var(--color-bg-card);\n    border: 1px solid var(--color-border);\n    padding: 12px 16px;\n    color: var(--color-text-primary);\n    font-family: 'Outfit', sans-serif;\n    font-size: 14px;\n    border-radius: 0;\n  }\n  \n  .chatbot-input::placeholder {\n    color: var(--color-text-muted);\n  }\n  \n  .chatbot-input:focus {\n    outline: none;\n    border-color: var(--color-primary);\n  }\n  \n  .chatbot-send-btn {\n    width: 44px;\n    height: 44px;\n    background: linear-gradient(135deg, var(--color-primary) 0%, #e88f1f 100%);\n    border: none;\n    color: var(--color-bg-dark);\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: opacity 0.2s;\n    flex-shrink: 0;\n    border-radius: 0;\n  }\n  \n  .chatbot-send-btn:hover:not(:disabled) {\n    opacity: 0.9;\n  }\n  \n  .chatbot-send-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n  }\n  \n  /* Responsive */\n  @media (max-width: 1200px) {\n    .performance-grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .modal-stats-grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .fit-score-grid {\n      grid-template-columns: repeat(3, 1fr);\n    }\n    \n    .hero-title {\n      font-size: 42px;\n    }\n  }\n  \n  @media (max-width: 768px) {\n    .header {\n      flex-direction: column;\n      gap: 12px;\n      padding: 16px 24px;\n    }\n    \n    .main-content {\n      padding: 24px;\n    }\n    \n    .hero-title {\n      font-size: 32px;\n    }\n    \n    .hero-subtitle {\n      font-size: 15px;\n    }\n    \n    .campaign-input-card {\n      padding: 16px;\n    }\n    \n    .input-row {\n      flex-direction: column;\n    }\n    \n    .upload-box {\n      flex-direction: row;\n      padding: 12px 16px;\n    }\n    \n    .performance-grid {\n      grid-template-columns: 1fr;\n    }\n    \n    .filters-bar {\n      flex-wrap: wrap;\n    }\n    \n    .influencers-table {\n      display: block;\n      overflow-x: auto;\n    }\n    \n    .insights-grid {\n      grid-template-columns: 1fr;\n    }\n    \n    .modal-stats-grid {\n      grid-template-columns: 1fr;\n    }\n    \n    .fit-score-grid {\n      grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .modal-footer {\n      flex-direction: column;\n    }\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
